import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { environment } from 'src/environments/environment';

export const authConfig: UserManagerSettings = {
  authority: 'https://accounts.google.com',
  client_id: '121734872211-8q80fa0n5iavsu8ljj5elg0ffsdqpb95.apps.googleusercontent.com',
  redirect_uri: `${environment.redirectUri}auth-callback`,
  post_logout_redirect_uri: `${environment.redirectUri}`,
  response_type: 'code', // PKCE flow
  scope: 'openid profile email',
  automaticSilentRenew: false,
  //silent_redirect_uri: 'http://localhost:4200/silent-renew.html',
  loadUserInfo: true,
  client_secret:'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',
   extraQueryParams: {
    access_type: 'offline',
    prompt: 'consent'
  },
  userStore: new WebStorageStateStore({
   store: window.localStorage
  })
};